var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ToggleStyle from './ToggleStyle';
import ownerDocument from '../../utils/ownerDocument';
import usePassPropsToChildren from '../../utils/hooks/usePassPropsToChildren';
import useActionOnEscape from '../../utils/hooks/useActionOnEscape';
import ToggleButton from '../Button/ToggleButton/ToggleButton';
import BackDrop from '../BackDrop/BackDrop';
// Todo: refactor this to Collapse component https://github.com/Amsterdam/amsterdam-styled-components/issues/379
const Toggle = (_a) => {
    var { children: childrenProps, onClick, open: openProp, onKeyDown, onOpen, css, render, iconOpen, iconClose, ToggleHandler, title, hasBackDrop, backdropOpacity, zIndexOffset, ariaLabel } = _a, otherProps = __rest(_a, ["children", "onClick", "open", "onKeyDown", "onOpen", "css", "render", "iconOpen", "iconClose", "ToggleHandler", "title", "hasBackDrop", "backdropOpacity", "zIndexOffset", "ariaLabel"]);
    const [open, setOpen] = React.useState(false);
    const handleOnOpen = React.useCallback((openParam) => {
        setOpen(openParam);
        if (onOpen) {
            onOpen(openParam);
        }
    }, 
    // Empty dependency array prevents an infinite loop if the parent rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const { onKeyDown: onKeyDownHook } = useActionOnEscape(() => handleOnOpen(false));
    const ref = React.useRef(null);
    const handleOnBlur = () => {
        setTimeout(() => {
            const element = ref.current;
            if (element) {
                const currentFocus = ownerDocument(element).activeElement;
                if (!element.contains(currentFocus)) {
                    handleOnOpen(false);
                }
            }
        });
    };
    const handleOnKeyDown = (e) => {
        onKeyDownHook(e);
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    const handleOnClick = (e) => {
        handleOnOpen(!open);
        if (onClick) {
            onClick(e);
        }
    };
    const { children } = usePassPropsToChildren(childrenProps, {
        'aria-hidden': !open,
    });
    // Useful if parent needs to take over control the isOpen state
    React.useEffect(() => {
        if (typeof openProp !== 'undefined') {
            handleOnOpen(openProp);
        }
    }, [handleOnOpen, openProp]);
    const conditionalRenderedChildren = open ? children : null;
    return (React.createElement(ToggleStyle, Object.assign({ ref: ref, css: css, onBlur: handleOnBlur, onKeyDown: handleOnKeyDown, hasBackDrop: hasBackDrop }, otherProps, { tabIndex: -1 }),
        ToggleHandler && (React.createElement(ToggleHandler, Object.assign({}, {
            open,
            iconClose,
            iconOpen,
            onClick: handleOnClick,
            title,
            hasBackDrop,
        }, (ariaLabel ? { 'aria-label': ariaLabel } : {}), { type: "button" }))),
        render ? children : conditionalRenderedChildren,
        hasBackDrop && open && (React.createElement(BackDrop, { onClick: handleOnClick, zIndexOffset: zIndexOffset, backdropOpacity: backdropOpacity }))));
};
Toggle.defaultProps = {
    render: true,
    ToggleHandler: ToggleButton,
};
export default Toggle;
//# sourceMappingURL=Toggle.js.map